module.exports = __webpack_public_path__ + "static/img/bg_rank.5a3c7d7c.png";